var entryId = bShare.addEntry({
    title: "《铁甲雄兵》斩龙战神·新年首套全新皮肤，只为吕布精心打造_云蟾游戏",
    summary: "《铁甲雄兵》喜迎新年，来一套吕布·斩龙战神皮肤再战2019。",
    pic: "http://bos.ycgame.com/act/1809lb/images/200x200.jpg",
});
$('.qq').on("click", function (e) {
    bShare.share(e, "qqim", entryId)
});
$('.wx').on("click", function (e) {
    bShare.share(e, "weixin", entryId)
});
$('.qzone').click(function (e) {
    bShare.share(e, "qzone", entryId)
});
$('.sina').click(function (e) {
    bShare.share(e, "sinaminiblog", entryId)
});
$('.baidu').click(function (e) {
    bShare.share(e, "itieba", entryId)
});


//////////////////
// WEBPACK FOOTER
// ./share.js
// module id = 1
// module chunks = 0